var _rect, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect2, _rect3, _rect4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 751,
    height: 428,
    viewBox: "0 0 751 428",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4008_38350)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 751,
    height: 428,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4008_38350)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M584.41 -51.001C584.41 37.8893 511.728 110.409 421.5 110.409C331.272 110.409 258.59 37.8893 258.59 -51.001C258.59 -139.891 331.272 -212.411 421.5 -212.411C511.728 -212.411 584.41 -139.891 584.41 -51.001Z",
    stroke: "black",
    strokeWidth: 71.18
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.1732,
    cy: 76.1732,
    r: 76.1732,
    transform: "matrix(-0.186751 -0.982407 -0.982407 0.186751 159.117 145.666)",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.445,
    cy: 102.445,
    r: 102.445,
    transform: "matrix(0.894157 -0.447754 -0.447754 -0.894157 191.738 427.943)",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 563.159,
    cy: 227.198,
    r: 63.7318,
    transform: "rotate(95.7089 563.159 227.198)",
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 421.949,
    cy: -32.0512,
    r: 317.24,
    transform: "rotate(95.7089 421.949 -32.0512)",
    stroke: "black",
    strokeWidth: 100
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 550.479,
    cy: 164.165,
    r: 63.7318,
    transform: "rotate(95.7089 550.479 164.165)",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "exclusion"
    }
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.2152,
    cy: 79.2152,
    r: 42.5,
    transform: "matrix(0.894157 -0.447754 -0.447754 -0.894157 141.262 81.5947)",
    stroke: "#AEAEAE",
    strokeWidth: 73.4304
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 751,
    height: 684.8,
    fill: "#878787"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 751,
    height: 684.8,
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 751,
    height: 684.8,
    transform: "translate(0 -0.000976562)",
    fill: "#FFD550"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4008_38350",
    x: -100.129,
    y: -528,
    width: 1018.03,
    height: 1114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 47,
    result: "effect1_foregroundBlur_4008_38350"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4008_38350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 751,
    height: 428,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg);
export default __webpack_public_path__ + "static/media/hero_bg.51c95fc80272d60df03b9272d2516151.svg";
export { ForwardRef as ReactComponent };